function SectionThree(){
    return(
        <section className="articles">
            <article className="article txt-cyan-dark article--graphic">
            <h3 className="fs-heading-medium fw-black">Graphic Design</h3>
            <p className="article--para fs-txt"> Great design makes you memorable. We deliver artwork that underscores your brand message and captures potential clients’ attention.</p>
            </article>
            <article className="article txt-blue article--photography">
            <h3 className="fs-heading-medium fw-black ">Photography</h3>
            <p className="article--para fs-txt"> Increase your credibility by getting the most stunning, high-quality photos that improve your business image.</p>
            </article>
        </section>
    )
}
export default SectionThree;